import { Component, HostListener, ViewChild, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate';

//PARA CANVAS//
let imageUno = new Image();
let imageDos = new Image();

let fotoCargada1: boolean = false;
let fotoCargada2: boolean = false;


//AL INCIO O AL RECARGAR ELIMINAMOS SHOW HOME Y VAMOS AL TOP
window.onbeforeunload = function() {
  document.getElementById('home').classList.remove("showHome");
  let inicio = document.getElementById('home');
  inicio.scrollIntoView();
}

let goToInicio = ()=> {
  let destino = document.getElementById('inicio');
  let destinoTop:number = destino.offsetTop;
  window.scroll({ top:destinoTop, left: 0, behavior: 'smooth' });
  /*
  setTimeout(()=>{
    let destino = document.getElementById('inicio');
    let destinoTop:number = destino.offsetTop;
    window.scroll({ top:destinoTop, left: 0, behavior: 'smooth' });
  }, 2000)*/
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})


export class MainComponent implements OnInit {
  constructor(  private translate:TranslateService  ){
  }
  //PARA CANVAS
  @ViewChild('canvas') canvas;
  canvasElement: any;
  ctx:any;

  isCanvasLoad:boolean = false;

  ancho:number = 0;
  anchoUno:number = 0;
  anchoDos:number = 0;
  alto:number = 0;
  altoUno:number = 0;
  altoDos:number = 0;

  tickActual:number = 0;
  anchoPorTick:number = 0;
  timer:any;
  duration: number = 2000;
  durationPorTick = 20;
  totalTicks:number = this.duration / this.durationPorTick;

  //FUNCION DE INICIO ANIMACION
  homeInicio = ( )=> {
    //MOSTRAMOS LA ANIMACION TEXTO
    setTimeout( ()=>{
      document.getElementById('home').classList.add("showHome");
    }, 1500)
    //actualizarCanvas(tickActual * anchoPorTick);


    //SACAMOS LA FOTO 1
    setTimeout( ()=> {
      document.getElementById('elCanvas').classList.add("showFoto1");
    },2500 )


    //SACAMOS LA FOTO 2
    setTimeout( ()=> {
      this.iniciarAnimacion();
    },4300 )

  }



  iniciarAnimacion = ( )=> {
    this.timer = setInterval(this.tickAnimacion, this.durationPorTick);

  }

  tickAnimacion = () => {
    if (this.tickActual <= this.totalTicks) {
          this.tickActual++;
          this.actualizarCanvas(this.tickActual * this.anchoPorTick);
      }
      else {
          clearTimeout(this.timer);
          //goToInicio();
          document.getElementById('canvasAnimacionBoton').classList.add("showBoton");
      }
    }

  actualizarCanvas = (anchoActual) => {
    this.anchoUno = this.ancho - anchoActual  - 1;
    this.anchoDos = anchoActual  - 1;

    if (this.anchoUno > this.ancho)this. anchoUno = this.ancho;
    if (this.anchoDos > this.ancho) this.anchoDos = this.ancho;

    this.ctx.drawImage(imageUno, 0, 0, this.anchoUno, this.alto, 0, 0, this.anchoUno, this.alto);
    this.ctx.drawImage(imageDos, this.anchoUno, 0, this.anchoDos, this.alto, this.anchoUno, 0, this.anchoDos, this.alto);
  }


  goToInicio = ( )=> {
    setTimeout(()=>{
      let destino = document.getElementById('inicio');
      let destinoTop:number = destino.offsetTop;
      window.scroll({ top:destinoTop, left: 0, behavior: 'smooth' });
    }, 1500)
  }

  ngAfterViewInit(){
    this.canvasElement = this.canvas.nativeElement;
    this.ctx = this.canvasElement.getContext('2d');
    this.ancho = this.canvasElement.width;
    this.alto = this.canvasElement.height;

    this.anchoPorTick = this.ancho / this.totalTicks;

    //load imagen 1
    imageUno.onload = () =>
    {
        this.ctx .drawImage(imageUno, 0, 0);
        this.ctx .beginPath();
        this.ctx .rect(0,0,this.canvasElement.width,this.canvasElement.height);
        this.ctx .stroke();
        fotoCargada1 = true;
    };
    imageUno.src = 'assets/img/home/bg-home-1.jpg';

    //load imagen 2
    imageDos.onload = () =>
    {
        this.ctx .beginPath();
        //this.ctx .rect(0,0,this.canvasElement.width,this.canvasElement.height);
        this.ctx .stroke();
        fotoCargada2 = true;
    };
    imageDos.src = 'assets/img/home/bg-home-2.jpg';
  }

  ngOnInit(){
    this.homeInicio(); //INCIAMOS ANIMACION
  }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/main/main.component.ts